import { render, staticRenderFns } from "./CommodityOrder.vue?vue&type=template&id=01219de8&scoped=true"
import script from "./CommodityOrder.vue?vue&type=script&lang=js"
export * from "./CommodityOrder.vue?vue&type=script&lang=js"
import style0 from "./CommodityOrder.vue?vue&type=style&index=0&id=01219de8&prod&scoped=true&lang=scss"
import style1 from "./CommodityOrder.vue?vue&type=style&index=1&id=01219de8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01219de8",
  null
  
)

export default component.exports